import { styled } from 'styled-components';
import { Divider } from 'antd';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  gap: 24px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
  }
  max-width: 900px;
`;

export const ImageSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;

  @media (min-width: 768px) {
    max-width: 400px;
  }

  @media (min-width: 1024px) {
    max-width: 512px;
  }

  img {
    width: 100%;
    height: auto;
    border-radius: 12px;
    object-fit: cover;
  }
`;

export const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 8px 6px;
  gap: 16px;

  @media (min-width: 768px) {
    padding: 8px 6px;
  }
`;

export const Title = styled.h1`
  font-weight: bold;
  font-size: 1.5rem;
  text-align: left;
  color: ${({ theme }) => theme?.colors?.text?.headings};
  margin: 0;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  font-size: 1rem;
  text-align: left;
  font-weight: 400;

  @media (max-width: 767px) {
    margin: 0;
  }
`;

export const Subtitle = styled.h2`
  font-weight: normal;
  font-size: 14px;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
  text-align: left;
`;

export const BoldText = styled.h1`
  font-weight: bold;
  font-size: 1rem;
  text-align: left;
  margin-bottom: 16px;
  color: ${({ theme }) => theme?.colors?.text?.headings};
`;


export const DetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 8px 0;
  font-size: 1rem;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};

  &:nth-child(1) {
    font-weight: bold;
  }
`;

export const StyledDivider = styled(Divider)`
    height: 1px;
    align-self: stretch;
    border-bottom: 1px solid ${({ theme }) => theme?.colors?.text?.muted};  
`;
